/**
 * Vias Element Colors — default color per mappable element type
 *
 * @module core/modules/vias/constants/element-colors
 *
 * @description
 * Colores por defecto para los 6 tipos de elementos del módulo de vías
 * que se representan en el mapa. El usuario puede personalizar cada color
 * desde el panel.
 */

/** The 6 vias element types that have map representation */
export type ViasElementId =
  | 'segments'
  | 'intersections'
  | 'signage'
  | 'bike_lanes'
  | 'condition'
  | 'projects';

export const VIAS_ELEMENT_COLORS: Record<ViasElementId, string> = {
  'segments':      '#64748b', // gris azulado (segmentos viales)
  'intersections': '#f59e0b', // ámbar (intersecciones)
  'signage':       '#ef4444', // rojo (señalización)
  'bike_lanes':    '#10b981', // verde (ciclovías)
  'condition':     '#eab308', // amarillo (estado)
  'projects':      '#8b5cf6', // violeta (proyectos)
};

/** Set of IDs for quick lookup */
export const MAPPABLE_ELEMENT_IDS = new Set<string>(
  Object.keys(VIAS_ELEMENT_COLORS),
);
